import { configureStore } from '@reduxjs/toolkit';
import counterReducer from './slices/counter';
import contactReducer from './slices/contacts';
import reportReducer from './slices/ReportSlice';
import reportReducerwl from './slices/ReportSliceWl';
import teamReducer from './slices/TeamSlice';
import settingReducer from './slices/SettingSlice';
import verifyInfoReducer from './slices/VerifyInfoSlice';
import uploadDocumentReducer from './slices/UploadDocumentSlice';
import mailingOptionReducer from './slices/MailingOptionSlice';
import recommandationReducer from './slices/RecommendationSlice';
import checkoutReducer from './slices/CheckoutSlice';
import creditReportReducer from './slices/CreditReportSlice';
import dashboardReducer from './slices/DashboardSlice';
import disputeCenterReducer from './slices/DisputeCenterSlice';
import enchanceDisputeReducer from './slices/EnhanceDisputeSlice';
import creditBuilderReducer from './slices/CreditBuilderSlice';
import commonReducer from './slices/CommonSlice';
import creditAuditReducer from './slices/CreditAuditSlice';
import reportAuditReducer from './slices/ReportAuditSlice';
import tourProgressSliceReducer from './slices/TourProgressSlice';
import IdiqApiReducer from './slices/IdiqApiSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    contacts: contactReducer,
    reports: reportReducer,
    reportswl: reportReducerwl,
    teams: teamReducer,
    setting: settingReducer,
    verifyInfo: verifyInfoReducer,
    uploadDocument: uploadDocumentReducer,
    mailingOption: mailingOptionReducer,
    recommandation: recommandationReducer,
    checkout: checkoutReducer,
    creditReport: creditReportReducer,
    dashboard: dashboardReducer,
    disputeCenter: disputeCenterReducer,
    enhanceDispute: enchanceDisputeReducer,
    creditBuilder: creditBuilderReducer,
    common: commonReducer,
    creditAudit: creditAuditReducer,
    reportAudit: reportAuditReducer,
    tourProgress: tourProgressSliceReducer,
    idiqApi:IdiqApiReducer
  },
});
